<div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
        <h1 class="govuk-heading-xl"> {{this.selectedDepartment?.extra?.booking_details_page_title}}</h1>
    </div>

    <div class="govuk-grid-column-two-thirds">

        <form [formGroup]="customerDetailsForm">
            <h2 class="govuk-heading-l">{{'FORM.YOUR_TITLE' | translate}}</h2>

            <div class="govuk-form-group"
                [ngClass]="{'govuk-form-group--error': form.first_name.errors?.required == true && submitted}">
                <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--m" for="first_name">
                        <span aria-hidden="true" class="form-field-required-marker">
                            *</span> {{'COMMON.FIRST_NAME' | translate}}
                    </label>
                </h1>
                <p *ngIf="submitted && form.first_name?.errors" id="event-name-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate: {value:
                    'COMMON.FIRST_NAME' | translate } }}
                </p>
                <input formControlName="first_name" class="govuk-input" id="first_name" name="eventName" type="text"
                    (change)="radioCopyChange()"
                    [ngClass]="{'govuk-input--error': form.first_name.errors?.required == true && submitted }">
            </div>

            <!-- <h2 class="mt-1 pb-4">{{'FORM.YOUR_TITLE' | translate}}</h2>
            <div class="govuk-form-group">
                <label tabindex="0" for="fn"> <span aria-hidden="true" class="form-field-required-marker">
                        *</span> {{'COMMON.FIRST_NAME' | translate}}</label>
                <input id="fn" type="text" class="form-control" formControlName="first_name" role="textbox">
                <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                    <div *ngIf="form.first_name.errors?.required" role="alert" tabindex="0">
                        {{ 'COMMON.IS_REQUIRED' | translate: {value: 'COMMON.FIRST_NAME' | translate } }}
                    </div>
                </div>
            </div> -->

            <div class="govuk-form-group"
                [ngClass]="{'govuk-form-group--error': form.last_name.errors?.required == true && submitted}">
                <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--m" for="last_name">
                        <span aria-hidden="true" class="form-field-required-marker">
                            *</span> {{'COMMON.LAST_NAME' | translate}}
                    </label>
                </h1>
                <p *ngIf="submitted && form.last_name.errors" id="event-name-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate: {value:
                    'COMMON.LAST_NAME' | translate } }}
                </p>
                <input formControlName="last_name" class="govuk-input" id="last_name" name="eventName" type="text"
                    (change)="radioCopyChange()"
                    [ngClass]="{'govuk-input--error': form.last_name.errors?.required == true && submitted }">
            </div>

            <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error': 
                  (form.email_address.errors?.required || form.email_address.errors?.pattern) 
                  && submitted
              }">
                <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--m" for="email_address">
                        <span aria-hidden="true" class="form-field-required-marker">
                            *</span> {{'COMMON.EMAIL_ADDRESS' | translate}}
                    </label>
                </h1>

                <p *ngIf="submitted && form.email_address?.errors" id="event-name-error" class="govuk-error-message">
                    <!-- required -->
                    <ng-container *ngIf="form.email_address?.errors?.required">
                        <span class="govuk-visually-hidden">Error:</span>
                        {{ 'COMMON.IS_REQUIRED' | translate: {value:
                        'COMMON.EMAIL_ADDRESS' | translate } }}
                    </ng-container>
                    <!-- pattern -->
                    <ng-container *ngIf="form.email_address?.errors?.pattern">
                        <span class="govuk-visually-hidden">Error:</span>
                        {{ 'COMMON.INVALID' | translate: {value:
                        'COMMON.EMAIL_ADDRESS' | translate } }}
                    </ng-container>
                </p>

                <input formControlName="email_address" class="govuk-input" id="email_address" name="eventName"
                    (change)="radioCopyChange()" type="text"
                    [ngClass]="{'govuk-input--error': form.email_address.errors?.required == true && submitted }">

                <fieldset *ngIf="adminJourney" class="govuk-fieldset" aria-describedby="email_address_consent">
                    <br />
                    <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                        <div class="govuk-checkboxes__item">
                            <input formControlName="email_address_consent" class="govuk-checkboxes__input"
                                id="email_address_consent_box" name="email_address_consent_box" type="checkbox"
                                value="carcasses">

                            <label class="govuk-label govuk-checkboxes__label" for="email_address_consent_box">
                                {{'COMMON.ADMIN_EMAIL_HINT' | translate}}
                            </label>
                        </div>
                    </div>
                    <p class="govuk-error-message" *ngIf="submitted && form.email_address_consent.errors">
                        <span class="govuk-visually-hidden">Error:</span> As we are going to be using email as the point
                        of reminding customers about their ceremony, we really need to ensure that this is correct at
                        the booking.
                    </p>
                </fieldset>
            </div>

            <div *ngIf="adminJourney">
                <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                    data-module="govuk-notification-banner">
                    <div class="govuk-notification-banner__header">
                        <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                            ADMIN GUIDANCE: Email address required
                        </h2>
                    </div>
                    <div class="govuk-notification-banner__content">
                        <p aria-label="Notification message"
                            class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                            style="font-weight: 500 !important; font-size: 19px !important;">
                            {{'COMMON.ADMIN_EMAIL_NOTIFICATION' | translate}} <br /><br />
                            {{'COMMON.ADMIN_EMAIL_NOTIFICATION_TWO' | translate}}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Passwords -->
            <ng-container *ngIf="!adminJourney">
                <div class="govuk-form-group govuk-password-input" data-module="govuk-password-input" #password>
                    <h1 class="govuk-label-wrapper">
                        <label class="govuk-label govuk-label--m" for="password-input">
                            <span aria-hidden="true" class="form-field-required-marker">
                                *</span> {{'COMMON.PASSWORD' | translate}}
                        </label>
                    </h1>
                    <div id="password-name-hint" class="govuk-hint">
                        {{'COMMON.PASSWORD_HINT' | translate}}
                    </div>
                    <div id="password-name-hint" class="govuk-hint">
                        {{'COMMON.PASSWORD_HINT_TWO' | translate}}
                    </div>
                    <p *ngIf="submitted && form.password?.errors" id="event-name-error" class="govuk-error-message">
                        <span *ngIf="form.password?.errors?.passwordInvalid" class="govuk-visually-hidden">Error:</span>
                        {{
                        'COMMON.PASSWORD_PATTERN' | translate}}
                    </p>
                    <div class="govuk-input__wrapper govuk-password-input__wrapper">
                        <input class="govuk-input govuk-password-input__input govuk-js-password-input-input"
                            id="password-input" formControlName="password" name="password" type="password"
                            spellcheck="false" autocomplete="current-password" autocapitalize="none">
                        <button type="button"
                            class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle"
                            data-module="govuk-button" aria-controls="password-input" aria-label="Show password" hidden>
                            Show
                        </button>
                    </div>
                </div>
            </ng-container>


            <!-- Passwords end-->

            <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error': 
                  (form.contact_number.errors?.required || 
                   form.contact_number.errors?.pattern || 
                   form.contact_number.errors?.minlength || 
                   form.contact_number.errors?.maxlength) 
                  && submitted
              }">
                <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--m" for="contact_number">
                        <span aria-hidden="true" class="form-field-required-marker">
                            *</span> {{'COMMON.CONTACT_NUMBER' | translate}}
                    </label>
                </h1>
                <div id="event-name-hint" class="govuk-hint">
                    {{'COMMON.PHONE_HINT' | translate}}
                </div>
                <div id="event-name-hint" class="govuk-hint">
                    {{'COMMON.PHONE_HINT_TWO' | translate}}
                </div>
                <p *ngIf="submitted && form.contact_number?.errors" id="event-name-error" class="govuk-error-message">
                    <!-- required -->
                    <ng-container *ngIf="form.contact_number?.errors?.required">
                        <span class="govuk-visually-hidden">Error:</span>
                        {{ 'COMMON.IS_REQUIRED' | translate: {value:
                        'COMMON.CONTACT_NUMBER' | translate } }}
                    </ng-container>
                    <!-- pattern -->
                    <ng-container *ngIf="form.contact_number?.errors?.pattern">
                        <span class="govuk-visually-hidden">Error:</span>
                        {{ 'COMMON.INVALID' | translate: {value:
                        'COMMON.CONTACT_NUMBER' | translate } }}
                    </ng-container>
                    <!-- minlength -->
                    <ng-container *ngIf="form.contact_number?.errors?.minlength">
                        <span class="govuk-visually-hidden">Error:</span>
                        {{ 'COMMON.INVALID' | translate: {value:
                        'COMMON.CONTACT_NUMBER' | translate } }}
                    </ng-container>
                    <!-- maxlength -->
                    <ng-container *ngIf="form.contact_number?.errors?.maxlength">
                        <span class="govuk-visually-hidden">Error:</span>
                        {{ 'COMMON.INVALID' | translate: {value:
                        'COMMON.CONTACT_NUMBER' | translate } }}
                    </ng-container>
                </p>
                <input formControlName="contact_number" class="govuk-input" id="contact_number" name="eventName"
                    (change)="radioCopyChange();" (keypress)="keyPressNumberField($event);" type="text" maxlength="13"
                    [ngClass]="{'govuk-input--error': form.contact_number.errors?.required == true && submitted }">

                <fieldset *ngIf="adminJourney" class="govuk-fieldset" aria-describedby="contact_number_consent">
                    <br />
                    <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                        <div class="govuk-checkboxes__item">
                            <input formControlName="contact_number_consent" class="govuk-checkboxes__input"
                                id="contact_number_consent_box" name="contact_number_consent_box" type="checkbox"
                                value="carcasses">

                            <label class="govuk-label govuk-checkboxes__label" for="contact_number_consent_box">
                                {{'COMMON.ADMIN_CONTACT_NUMBER_HINT' | translate}}
                            </label>
                        </div>
                    </div>
                    <p class="govuk-error-message" *ngIf="submitted && form.contact_number_consent.errors">
                        <span class="govuk-visually-hidden">Error:</span> As we are going to be using the contact number
                        as the point of reminding customers about their ceremony, we really need to ensure that this is
                        correct at the booking.
                    </p>
                </fieldset>
            </div>

            <div class="govuk-radios" data-module="govuk-radios" role="radiogroup" aria-labelledby="copyDataLabel">
                <h1 class="govuk-label-wrapper" id="copyDataLabel">
                    <span class="govuk-label govuk-label--m">
                        {{'COMMON.COPY_DETAILS' | translate}}
                    </span>
                </h1>
                <div class="govuk-radios" data-module="govuk-radios">
                    <div class="govuk-radios__item">
                        <input formControlName="copyData" (change)="updateRadio(customerDetailsForm,'copyData','Yes')"
                            class="govuk-radios__input" id="Yes" name="copyData" type="radio" value="Yes">
                        <label class="govuk-label govuk-radios__label" for="Yes">
                            Yes
                        </label>
                    </div>
                    <div class="govuk-radios__item">
                        <input formControlName="copyData" (change)="updateRadio(customerDetailsForm,'copyData','No')"
                            class="govuk-radios__input" id="No" name="copyData" type="radio" value="No">
                        <label class="govuk-label govuk-radios__label" for="No">
                            No
                        </label>
                    </div>
                </div>
            </div>

            <!-- Customer questions -->
            <div *ngFor="let question of customerQuestions;">

                <!-- questions that arent required -->
                <ng-container *ngIf="!question.required">
                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type == 'text_field'">

                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--m" for="{{question.reference}}">
                                {{question.name | translate}}
                            </label>
                        </h1>
                        <input formControlName="{{question.reference}}" class="govuk-input" id="{{question.reference}}"
                            name="{{question.reference}}" type="text">
                    </div>

                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--l" for="more-detail">
                                Can you provide more detail?
                            </label>
                        </h1>
                        <div id="more-detail-hint" class="govuk-hint">
                            Do not include personal or financial information, like your National Insurance number or
                            credit card details
                        </div>
                        <textarea class="govuk-textarea" id="more-detail" name="moreDetail" rows="5"
                            aria-describedby="more-detail-hint"></textarea>
                    </div>


                    <h1 class="govuk-label-wrapper">
                        <label class="govuk-label govuk-label--m" for="{{question.reference}}">
                            {{question.name | translate}}
                        </label>
                    </h1>

                    <input formControlName="{{question.reference}}" class="govuk-input" id="{{question.reference}}"
                        name="{{question.reference}}" type="text">

                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type == 'number'">
                        <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>
                        <input type="search" class="form-control" formControlName="{{question.reference}}"
                            attr.aria-label="{{question.name}} input field" (keypress)="keyPressNumberField($event)"
                            maxlength="11">
                        <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit
                                } }}
                            </div>
                        </div>
                    </div>

                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'select' || question.visible && question.detail_type == 'select-price'">
                        <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>

                        <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                            id="{{question.reference}}" formControlName="{{question.reference}}" bindLabel="name"
                            bindValue="name" [items]="question.options" (change)="onQuestionChange();">
                        </ng-select>

                        <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit
                                } }}
                            </div>
                        </div>
                    </div>

                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'date' && question.id != 1">
                        <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>
                        <input matInput formControlName="{{question.reference}}" [matDatepicker]="picker" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker>
                        </mat-datepicker>
                        <span *ngIf="question.help_text" class="help-text  " tabindex="0"
                            [innerHTML]="question.help_text | translateSplit | noSanitise">
                        </span>
                        <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit
                                } }}
                            </div>
                            <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                {{'COMMON.AGE_VALIDATION' | translate}}</div>
                        </div>
                    </div>

                    <!-- checkbox -->
                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'check' || question.visible && question.detail_type == 'check-price'">
                        <mat-checkbox formControlName="{{question.reference}}" class="">
                            <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">
                                    *</span></label>
                            <span *ngIf="question.price == 0">{{question.name}}</span>

                            <span tabindex="-1" *ngIf="question.price > 0">{{question.name}} -
                                {{question.price / 100 | currency:'GBP':true}}</span>
                        </mat-checkbox>

                        <span *ngIf="question.help_text" class="help-text  " tabindex="0"
                            innerHTML="question.help_text | translateSplit | noSanitise">
                        </span>

                        <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                            class="invalid-feedback">
                            {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit } }}
                        </div>
                        <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                            {{question?.validation_message}}
                        </div>
                    </div>
                </ng-container>

                <!-- questions that are required -->
                <ng-container *ngIf="question.required">
                    <div class="govuk-form-group"
                        [ngClass]="{'govuk-form-group--error': form[question.reference].errors?.required == true && submitted}"
                        *ngIf="question.visible && question.detail_type == 'text_field'">

                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--m" for="{{question.reference}}">
                                <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                    *</span> {{question.name | translate}}
                            </label>
                        </h1>
                        <p *ngIf="submitted && form[question.reference].errors?.errors" id="event-name-error"
                            class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate:
                            {value: question.name | translate } }}
                        </p>
                        <input formControlName="{{question.reference}}" class="govuk-input" id="{{question.reference}}"
                            name="{{question.reference}}" type="text"
                            [ngClass]="{'govuk-input--error': form[question.reference].errors?.required == true && submitted }">
                    </div>

                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--l" for="more-detail">
                                Can you provide more detail?
                            </label>
                        </h1>
                        <div id="more-detail-hint" class="govuk-hint">
                            Do not include personal or financial information, like your National Insurance number or
                            credit card details
                        </div>
                        <textarea class="govuk-textarea" id="more-detail" name="moreDetail" rows="5"
                            aria-describedby="more-detail-hint"></textarea>
                    </div>

                    <h1 class="govuk-label-wrapper">
                        <label class="govuk-label govuk-label--m" for="{{question.reference}}">
                            <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                *</span> {{question.name | translate}}
                        </label>
                    </h1>

                    <input formControlName="{{question.reference}}" class="govuk-input" id="{{question.reference}}"
                        name="{{question.reference}}" type="text">

                    <div class="govuk-form-group" *ngIf="question.visible && question.detail_type == 'number'">
                        <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>
                        <input type="search" class="form-control" formControlName="{{question.reference}}"
                            attr.aria-label="{{question.name}} input field" (keypress)="keyPressNumberField($event)"
                            maxlength="11">
                        <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit
                                } }}
                            </div>
                        </div>
                    </div>

                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'select' || question.visible && question.detail_type == 'select-price'">
                        <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>

                        <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                            id="{{question.reference}}" formControlName="{{question.reference}}" bindLabel="name"
                            bindValue="name" [items]="question.options" (change)="onQuestionChange();">
                        </ng-select>

                        <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit
                                } }}
                            </div>
                        </div>
                    </div>

                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'date' && question.id != 1">
                        <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                class="form-field-required-marker">
                                *</span> {{question.name | translateSplit}}</label>
                        <input matInput formControlName="{{question.reference}}" [matDatepicker]="picker" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker>
                        </mat-datepicker>
                        <span *ngIf="question.help_text" class="help-text  " tabindex="0"
                            [innerHTML]="question.help_text | translateSplit | noSanitise">
                        </span>
                        <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                            <div *ngIf="form[question.reference].errors.required" role="alert">
                                {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit
                                } }}
                            </div>
                            <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                {{'COMMON.AGE_VALIDATION' | translate}}</div>
                        </div>
                    </div>

                    <!-- checkbox -->
                    <div class="govuk-form-group"
                        *ngIf="question.visible && question.detail_type == 'check' || question.visible && question.detail_type == 'check-price'">
                        <mat-checkbox formControlName="{{question.reference}}" class="">
                            <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">
                                    *</span></label>
                            <span *ngIf="question.price == 0">{{question.name}}</span>

                            <span tabindex="-1" *ngIf="question.price > 0">{{question.name}} -
                                {{question.price / 100 | currency:'GBP':true}}</span>
                        </mat-checkbox>

                        <span *ngIf="question.help_text" class="help-text  " tabindex="0"
                            innerHTML="question.help_text | translateSplit | noSanitise">
                        </span>

                        <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                            class="invalid-feedback">
                            {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit } }}
                        </div>
                        <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                            {{question?.validation_message}}
                        </div>
                    </div>
                </ng-container>


            </div>
            <br>
        </form>

        <div>
            <form [formGroup]="companyQuestionsForm">
                <div *ngFor="let question of companyQuestions;">
                    <!-- <pre> {{question.reference}} {{question.detail_type}} = {{question.name}} - {{question.id}} - {{question.detail_type}} - {{question.visible}} - {{ question.conditionals | json }}</pre> -->

                    <!-- multiline address lookup -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.address_lookup_multi_line">

                        <div class="govuk-form-group"
                            [ngClass]="{'govuk-form-group--error': companyQuestionsForm.get('postcode_' + question.reference)?.errors?.invalid_address}">
                            <label class="govuk-label govuk-label--m" for="postcode_{{question.reference}}">
                                <span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">*</span> {{question.name}}
                            </label>

                            <p *ngIf="companyQuestionsForm.get('postcode_' + question.reference)?.errors?.invalid_address"
                                id="event-name-error" class="govuk-error-message">
                                <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.INVALID_POSTCODE' |
                                translate}}
                            </p>

                            <div *ngIf="companyQuestionsForm.get('postcode_' + question.reference)?.errors?.invalid_address"
                                class="invalid-feedback">
                                <div role="alert">
                                    {{ 'COMMON.INVALID_POSTCODE' | translate}}
                                </div>
                            </div>

                            <input (keydown.space)="$event.preventDefault();"
                                (keydown.spacebar)="$event.preventDefault();" class="govuk-input"
                                id="postcode_{{question.reference}}" name="postcode_{{question.reference}}"
                                placeholder="Enter postcode" formControlName="postcode_{{question.reference}}"
                                type="text">
                        </div>

                        <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                            [innerHTML]="question.helptext">
                        </div>

                        <button type="button" class="govuk-button" data-module="govuk-button"
                            (click)="getAddress(question)">
                            {{'COMMON.FIND_ADDRESS' | translate}}
                        </button>

                        <div *ngIf="question.addresses">
                            <div class="govuk-form-group" *ngIf="question.addresses.length > 0">
                                <label class="govuk-label govuk-fieldset__legend--m" style="color: #00703c;"
                                    for="addresses">
                                    * Select address below
                                </label>
                                <select (change)="selectSuggestion($event.target.value, question); onQuestionChange();"
                                    formControlName="{{question.reference}}" class="govuk-select" id="addresses"
                                    name="addresses">

                                    <!-- Hidden placeholder shown only when no value is selected -->
                                    <option value="" disabled selected hidden>Select address</option>

                                    <ng-container *ngFor="let option of question['addresses']">
                                        <option [value]="option.address.UPRN">
                                            {{option.address['ADDRESS']}}
                                        </option>
                                    </ng-container>

                                </select>
                            </div>

                        </div>
                    </div>

                    <!-- single address lookup -->
                    <div [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && question.address_lookup && !question.address_lookup_multi_line">

                        <div class="govuk-form-group" [ngClass]="{
                            'govuk-form-group--error': 
                              submitted && bookingForm[question.reference]?.errors
                          }">
                            <label class="govuk-label govuk-fieldset__legend--m" for="postcode_{{question.reference}}">
                                <span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">*</span> {{question.name}}
                            </label>
                            <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                [form]="bookingForm" [question]="question"></app-form-error-messages>
                            <input
                                [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                (keydown.space)="$event.preventDefault();" (keydown.spacebar)="$event.preventDefault();"
                                class="govuk-input govuk-input--width-20" id="postcode_{{question.reference}}"
                                name="postcode_{{question.reference}}" placeholder="Enter postcode"
                                formControlName="postcode_{{question.reference}}" type="text">
                        </div>

                        <button type="button" class="govuk-button" data-module="govuk-button"
                            (click)="getAddress(question)">
                            {{'COMMON.FIND_ADDRESS' | translate}}
                        </button>

                        <div *ngIf="question.addresses">
                            <div class="govuk-form-group" [ngClass]="{
                                'govuk-form-group--error': 
                                  ((bookingForm[question.reference].errors?.required || 
                                   bookingForm[question.reference].errors?.pattern || 
                                   bookingForm[question.reference].errors?.minlength || 
                                   bookingForm[question.reference].errors?.maxlength)  && submitted)
    
                              }" *ngIf="question.addresses.length > 0">
                                <label class="govuk-label govuk-fieldset__legend--m" style="color: #00703c;"
                                    for="addresses">
                                    * Select address below
                                </label>
                                <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                    [form]="bookingForm" [question]="question"></app-form-error-messages>
                                <select
                                    [ngClass]="{'govuk-select--error': bookingForm[question.reference].errors?.required == true  && submitted && submitted }"
                                    (change)="validateQuestions($event, question); onQuestionChange(); setAddress($event, question);"
                                    formControlName="{{question.reference}}" class="govuk-select" id="addresses"
                                    name="addresses">

                                    <!-- Hidden placeholder shown only when no value is selected -->
                                    <option value="" disabled selected hidden>Select address</option>

                                    <ng-container *ngFor="let option of question['addresses']">
                                        <option [value]="option.address['ADDRESS']">
                                            {{option.address['ADDRESS']}}
                                        </option>
                                    </ng-container>

                                </select>
                            </div>

                            <!-- <div class="govuk-form-group" *ngIf="question.addresses.length > 0">
                                <label><span *ngIf="question.required" aria-hidden="true"
                                        class="form-field-required-marker">
                                        *</span>Select address below</label>
    
                                <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                                    id="{{question.reference}}" formControlName="{{question.reference}}"
                                    bindLabel="address.ADDRESS" bindValue="address.ADDRESS" [items]="question.addresses"
                                    (change)="validateQuestions($event, question); onQuestionChange();">
                                </ng-select>
                            </div> -->
                        </div>
                    </div>

                    <span [ngClass]="{'hidden-question': question.hidden}"
                        *ngIf="question.visible && !question.address_lookup && !question.address_lookup_multi_line">
                        <!-- select -->
                        <div class="govuk-form-group" [ngClass]="{
                            'govuk-form-group--error': 
                              submitted && bookingForm[question.reference]?.errors
                          }"
                            *ngIf="question.visible && (question.detail_type == 'select' || question.detail_type == 'select-price')">
                            <label class="govuk-label govuk-fieldset__legend--m" for="{{question.reference}}">
                                <span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">*</span> {{question.name}}
                            </label>
                            <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                [form]="bookingForm" [question]="question"></app-form-error-messages>
                            <select
                                [ngClass]="{'govuk-select--error': bookingForm[question.reference].errors && submitted }"
                                (change)="validateQuestions($event, question); onQuestionChange();"
                                formControlName="{{question.reference}}" class="govuk-select"
                                id="{{question.reference}}" name="{{question.reference}}">
                                <!-- <option value="" selected></option> -->
                                <option *ngFor="let option of question.options" [value]="option.name">
                                    {{option.name}}
                                </option>
                            </select>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- text field -->
                        <div class="govuk-form-group" [ngClass]="{
                            'govuk-form-group--error': 
                              submitted && bookingForm[question.reference]?.errors
                          }" *ngIf="question.visible && question.detail_type == 'text_field'">
                            <h1 class="govuk-label-wrapper">
                                <label class="govuk-label govuk-fieldset__legend--m" for="{{question.reference}}">
                                    <span *ngIf="question.required" aria-hidden="true"
                                        class="form-field-required-marker">*</span> {{question.name}}
                                </label>
                            </h1>
                            <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                [form]="bookingForm" [question]="question"></app-form-error-messages>
                            <input
                                [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                class="govuk-input" id="{{question.reference}}" name="eventName" type="text"
                                formControlName="{{question.reference}}"
                                (change)="validateQuestions($event, question); onQuestionChange();">
                        </div>

                        <!-- text area -->
                        <div class="govuk-form-group" [ngClass]="{
                            'govuk-form-group--error': 
                              submitted && bookingForm[question.reference]?.errors
                          }" *ngIf="question.visible && question.detail_type == 'text_area'">
                            <h1 class="govuk-label-wrapper">
                                <label class="govuk-label govuk-fieldset__legend--m" for="{{question.reference}}">
                                    <span *ngIf="question.required" aria-hidden="true"
                                        class="form-field-required-marker">*</span> {{question.name}}
                                </label>
                            </h1>
                            <div id="{{question.reference}}-hint" class="govuk-hint">
                                {{question.helptext}}
                            </div>
                            <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                [form]="bookingForm" [question]="question"></app-form-error-messages>
                            <textarea
                                [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                formControlName="{{question.reference}}" class="govuk-textarea"
                                id="{{question.reference}}" name="moreDetail" rows="5"
                                (change)="validateQuestions($event, question); onQuestionChange();"></textarea>
                        </div>


                        <!-- /////////////////////////////////////////// -->
                        <div *ngIf="question.visible && question.detail_type == 'date'" class="govuk-form-group"
                            [ngClass]="{
                            'govuk-form-group--error': 
                              (bookingForm[question.reference].errors?.required || 
                               bookingForm[question.reference].errors?.pattern || 
                               bookingForm[question.reference].errors?.minlength || 
                               bookingForm[question.reference].errors?.maxlength ||
                               bookingForm[question.reference].errors?.pastDate ||
                               bookingForm[question.reference].errors?.futureDate)
    
                          }">
                            <fieldset class="govuk-fieldset" role="group" [attr.aria-describedby]="question.id">
                                <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                                    <h1 class="govuk-fieldset__heading">
                                        <span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">*</span> {{question.name}}
                                    </h1>
                                </legend>
                                <div id="{{question.id}}" class="govuk-hint" *ngIf="question.helptext"
                                    [innerHTML]="question.helptext">
                                </div>
                                <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                    [form]="bookingForm" [question]="question"></app-form-error-messages>
                                <div class="govuk-date-input" id="passport-issued">
                                    <div class="govuk-date-input__item">
                                        <div class="govuk-form-group">
                                            <label class="govuk-label govuk-date-input__label" for="{{question.id}}_d">
                                                Day
                                            </label>
                                            <input
                                                [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                                (change)="validateQuestions($event, question); onQuestionChange();"
                                                class="govuk-input govuk-date-input__input govuk-input--width-2"
                                                id="{{question.id}}_d" name="{{question.id}}_d" type="text"
                                                inputmode="numeric">
                                        </div>
                                    </div>
                                    <div class="govuk-date-input__item">
                                        <div class="govuk-form-group">
                                            <label class="govuk-label govuk-date-input__label" for="{{question.id}}_m">
                                                Month
                                            </label>
                                            <input
                                                [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                                (change)="validateQuestions($event, question); onQuestionChange();"
                                                class="govuk-input govuk-date-input__input govuk-input--width-2"
                                                id="{{question.id}}_m" name="{{question.id}}_m" type="text"
                                                inputmode="numeric">
                                        </div>
                                    </div>
                                    <div class="govuk-date-input__item">
                                        <div class="govuk-form-group">
                                            <label class="govuk-label govuk-date-input__label" for="{{question.id}}_y">
                                                Year
                                            </label>
                                            <input
                                                [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors  && submitted }"
                                                (change)="validateQuestions($event, question); onQuestionChange();"
                                                class="govuk-input govuk-date-input__input govuk-input--width-4"
                                                id="{{question.id}}_y" name="{{question.id}}_y" type="text"
                                                inputmode="numeric">
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>


                        <!-- GOVUK radio -->
                        <div *ngIf="question.visible && (question.detail_type == 'radio' || question.detail_type == 'radio-price')"
                            class="govuk-form-group" [ngClass]="{
                            'govuk-form-group--error': 
                              submitted && bookingForm[question.reference]?.errors
                          }">
                            <fieldset class="govuk-fieldset"
                                [attr.aria-describedby]="question.helptext ? 'changedName-hint-' + question.reference : null">
                                <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                                    <span *ngIf="question.required" aria-hidden="true"
                                        class="form-field-required-marker">*</span> {{question.name}}
                                </legend>
                                <div id="changedName-hint-{{question.reference}}" class="govuk-hint"
                                    *ngIf="question.helptext" [innerHTML]="question.helptext">
                                </div>

                                <div class="govuk-radios" data-module="govuk-radios">
                                    <div class="govuk-radios__item" *ngFor="let option of question.options">
                                        <input
                                            [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                            formControlName="{{question.reference}}"
                                            (change)="updateRadio(companyQuestionsForm,question.reference,option.name)"
                                            class="govuk-radios__input" id="{{question.reference + '_' + option.name}}"
                                            name="{{question.reference}}" type="radio" [value]="option.name">
                                        <label class="govuk-label govuk-radios__label"
                                            for="{{question.reference + '_' + option.name}}">
                                            {{option.name}}
                                        </label>
                                    </div>
                                </div>
                                <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                    [form]="bookingForm" [question]="question"></app-form-error-messages>
                            </fieldset>
                        </div>


                        <!--CHECKBOX-->
                        <div class="govuk-form-group" [ngClass]="{
                            'govuk-form-group--error': 
                              submitted && bookingForm[question.reference]?.errors
                          }" *ngIf="question.visible && question.detail_type === 'check'">
                            <fieldset class="govuk-fieldset" [attr.aria-describedby]="question.id">
                                <!-- <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                                    <h1 class="govuk-fieldset__heading">
                                      Which types of waste do you transport?
                                    </h1>
                                  </legend> -->
                                <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                    [innerHTML]="question.helptext">
                                </div>
                                <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                                    [form]="bookingForm" [question]="question"></app-form-error-messages>
                                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                                    <div class="govuk-checkboxes__item">
                                        <input
                                            [ngClass]="{'govuk-input--error': bookingForm[question.reference].errors && submitted }"
                                            (change)="validateQuestions($event, question); onQuestionChange();"
                                            class="govuk-checkboxes__input" id="{{question.id}}" name="{{question.id}}"
                                            type="checkbox" value="{{question.id}}" formControlName="{{question.id}}">
                                        <label class="govuk-label govuk-checkboxes__label" for="{{question.id}}">
                                            {{question.name}}
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <!-- normal heading-->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading' && !question.conditionals.component_type">
                            <p [ngStyle]="{'color': question.customLabelColour}">
                                <b>{{question.name}}</b>
                            </p>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- file upload heading -->
                        <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'file-upload'">
                            <div class="govuk-form-group">
                                <label class="govuk-label govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse" for="{{ question.id }}">
                                    {{ question.name }}
                                </label>
                                <input (change)="
                      validateQuestions($event, question); onQuestionChange()" class="govuk-file-upload"
                                    id="{{ question.id }}" name="question.id" type="file">
                            </div>
                        </div>

                        <!-- inset heading -->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'inset_text'">
                            <div class="govuk-inset-text">
                                {{question.name}}
                            </div>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- details component type -->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'details'">
                            <details class="govuk-details">
                                <summary class="govuk-details__summary">
                                    <span class="govuk-details__summary-text">
                                        {{question.name}}
                                    </span>
                                </summary>
                                <div class="govuk-details__text" [innerHTML]="addHyperlinks(question)">
                                </div>
                            </details>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- notifcation banner heading -->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'notification_banner'">

                            <div class="govuk-notification-banner" role="region"
                                aria-labelledby="govuk-notification-banner-title"
                                data-module="govuk-notification-banner">
                                <div class="govuk-notification-banner__header">
                                    <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                                        {{question.name}}
                                    </h2>
                                </div>
                                <div class="govuk-notification-banner__content">
                                    <p class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                                        [innerHTML]="addHyperlinks(question)">
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- warning heading -->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'warning_text'">

                            <div class="govuk-warning-text">
                                <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                                <strong class="govuk-warning-text__text">
                                    <span class="govuk-visually-hidden">Warning</span>
                                    {{question.name}}
                                </strong>
                            </div>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- panel heading -->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading' && question.conditionals.component_type == 'panel'">

                            <div class="govuk-panel govuk-panel--confirmation">
                                <h1 class="govuk-panel__title">
                                    {{question.name}}
                                </h1>
                                <div class="govuk-panel__body" [innerHTML]="addHyperlinks(question)"></div>
                            </div>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                        <!-- heading 2 -->
                        <div [ngClass]="{'hidden-question': question.hidden}"
                            *ngIf="question.visible && question.detail_type == 'heading_2'">
                            <h2 class="govuk-heading-l" [ngStyle]="{'color': question.customLabelColour}">
                                {{question.name}}
                            </h2>
                            <div *ngIf="question.helptext" id="{{question.id}}" class="govuk-hint"
                                [innerHTML]="question.helptext">
                            </div>
                        </div>

                    </span>

                </div>
            </form>
        </div>

        <app-cost-breakdown *ngIf="selectedDepartment" [company]="selectedDepartment" [costBreakDown]="costBreakDown"
            [currentPage]="pageName"></app-cost-breakdown>

        <form [formGroup]="customerDetailsForm" autocomplete="off">

            <!--  terms and conditions -->
            <div class="govuk-form-group" [ngClass]="{'govuk-form-group--error': submitted && form.tnc.errors }">
                <fieldset class="govuk-fieldset" aria-describedby="tnc">
                    <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                        <h1 class="govuk-heading-l">
                            {{'FORM.TNCS.TNCS_TITLE' | translate}}
                        </h1>
                    </legend>
                    <p class="govuk-error-message" *ngIf="submitted && form.tnc.errors">
                        <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate }}
                    </p>
                    <div id="tnc" class="govuk-hint" [innerHTML]="tncPolicy">
                    </div>
                    <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                        <div class="govuk-checkboxes__item">
                            <input formControlName="tnc" class="govuk-checkboxes__input" id="tncPolicy" name="tncPolicy"
                                type="checkbox" value="carcasses">

                            <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="tncPolicy">
                                {{'COMMON.POLICY_AGREE' | translate}}
                            </label>

                            <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="tncPolicy">
                                {{'COMMON.POLICY_AGREE_ADMIN' | translate}}
                            </label>

                        </div>
                    </div>
                </fieldset>
            </div>

            <!--  service terms -->
            <div class="govuk-form-group"
                [ngClass]="{'govuk-form-group--error': submitted && form.service_policy.errors }">
                <fieldset class="govuk-fieldset" aria-describedby="service_policy">
                    <p class="govuk-error-message" *ngIf="submitted && form.service_policy.errors">
                        <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate }}
                    </p>
                    <div id="service_policy" class="govuk-hint" [innerHTML]="servicePolicy">
                    </div>
                    <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                        <div class="govuk-checkboxes__item">
                            <input formControlName="service_policy" class="govuk-checkboxes__input" id="service_policy"
                                name="service_policy" type="checkbox" value="carcasses">

                            <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label"
                                for="service_policy">
                                {{'COMMON.POLICY_AGREE' | translate}}
                            </label>

                            <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label"
                                for="service_policy">
                                {{'COMMON.POLICY_AGREE_ADMIN' | translate}}
                            </label>

                        </div>
                    </div>
                </fieldset>
            </div>

            <div class="govuk-form-group"
                [ngClass]="{'govuk-form-group--error': submitted && form.data_policy.errors }">
                <fieldset class="govuk-fieldset" aria-describedby="data_policy">
                    <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                        <h1 class="govuk-heading-l">
                            {{'COMMON.DATA_POLICY' | translate}}
                        </h1>
                    </legend>
                    <p class="govuk-error-message" *ngIf="submitted && form.data_policy.errors">
                        <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate }}
                    </p>
                    <div id="data_policy" class="govuk-hint" [innerHTML]="dataPolicy">
                    </div>
                    <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                        <div class="govuk-checkboxes__item">
                            <input formControlName="data_policy" class="govuk-checkboxes__input" id="datapolicy"
                                name="datapolicy" type="checkbox" value="carcasses">

                            <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="datapolicy">
                                {{'COMMON.POLICY_AGREE' | translate}}
                            </label>

                            <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="datapolicy">
                                {{'COMMON.POLICY_AGREE_ADMIN' | translate}}
                            </label>

                        </div>
                    </div>
                </fieldset>
            </div>
        </form>

        <div class="govuk-button-group">
            <button type="submit" class="govuk-button govuk-button--secondary" data-module="govuk-button"
                (click)="routerGoBack()">{{'COMMON.BACK' | translate}}
            </button>
            <button type="submit" class="govuk-button" data-module="govuk-button" (click)="onSubmit()">{{'COMMON.NEXT' |
                translate}}
            </button>
        </div>

    </div>

    <div class="govuk-grid-column-one-third">
        <app-booking-summary></app-booking-summary>
    </div>
</div>